import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'CUSTOMER' | 'ADMIN';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole = 'CUSTOMER'
}) => {
  const location = useLocation();
  const token = localStorage.getItem('accessToken');
  const userRole = localStorage.getItem('userRole') as 'CUSTOMER' | 'ADMIN' | 'SUPER_ADMIN' | null;

  console.log('[ProtectedRoute] Auth check:', {
    path: location.pathname,
    hasToken: !!token,
    userRole,
    requiredRole
  });

  // Check if user is authenticated
  if (!token) {
    console.log('[ProtectedRoute] No token - redirecting to login');
    // Redirect to login page with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has required role
  if (requiredRole === 'ADMIN' && userRole !== 'ADMIN' && userRole !== 'SUPER_ADMIN') {
    console.log('[ProtectedRoute] Insufficient role - redirecting to home');
    // Redirect to home page if user doesn't have admin role
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;